import * as React from 'react';

function SvgMailOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M20.077 4.3H3.923A1.923 1.923 0 002 6.223V17.76c0 1.062.861 1.923 1.923 1.923h16.154A1.923 1.923 0 0022 17.761V6.223A1.923 1.923 0 0020.077 4.3z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M5.077 7.377L12 12.762l6.923-5.385" })));
}

export default SvgMailOutline;
